import Products from "./products";
import { useNavigate } from "react-router-dom";
import { Calendars } from "./calendars";
import PaymentVids from "./payment-vids";
import Rooms from "./rooms";
import Ctrls from "./ctrls";
import Channels from "./channels";
import Patterns from "./patterns";
import Company from "./company";
import Users from "./users/users";
import Tokens from "./tokens";
import ReportDesigns from "./report-designs/report-designs";
import Catalogs from "./catalogs";
import Tags from "./tags/tags";
import { useEffect, useState } from "react";
import { message, Select } from "antd";
import { licenseModuleBase, licenseModuleAccessControl, licenseModuleWidget, licenseModuleMessages } from "@/extensions";
import { serverFetch } from "@/server";
import { isMobile } from "@/extensions/design";
import SettingsFilter from "./settings-filter";

const Settings = ( { page } ) => {
  const [company, setCompany] = useState();
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState();
  const activeLicenseModules = company?.activeLicense?.activeModules;
  useEffect(() => {
          serverFetch(`company/current`)
              .then(data => setCompany(data))
              .catch(e => message.error(e.userMessage));
  }, [])

  const hasActiveLicense = licenseModuleBase(activeLicenseModules);

  const pagesMobile = [
    { title: "Компания", link: "company" }, 
    { title: "Номенклатура", link: "products"},
    { title: "Пользователи", link: "users"}
  ];

  const handlePageChange = (newPage) => {
    navigate(`/settings/${newPage}`);
  };


  const getPage = () => {
    if (!hasActiveLicense) {
      if (page === "users") return <Users />;
      return <Company />;
    }
    switch (page) {
      case "products": return <Products filter={filter} />
      case "calendars": return <Calendars />
      case "company": return <Company />
      case "paymentvids": return <PaymentVids />
      case "rooms": return <Rooms />
      case "ctrls": return <Ctrls />
      case "channels": return <Channels />
      case "patterns": return <Patterns />
      case "users": return <Users />
      case "tokens": return <Tokens />
      case "reports": return <ReportDesigns />
      case "catalogs": return <Catalogs />
      case "tags": return <Tags />
      default: return null;
    }
  }

  const getItem = (title, link, id) => <a id={id} className={"col-one-title-item" + (link === page ? " col-one-title-selected " : "")} href={`/settings/${link}`}>{title}</a>

  return !isMobile ? (<div className="col-one-main settings-main">
    <div className="col-one-title">
      {getItem("Компания", "company", "tour-item-settings-menu-company")}
      {getItem("Пользователи", "users", "tour-item-settings-menu-users")}
      {hasActiveLicense && (
        <>
          {licenseModuleWidget(activeLicenseModules) ? getItem("Каталог", "catalogs") : null}
          {getItem("Номенклатура", "products", "tour-item-settings-menu-products")}
          {getItem("Календари", "calendars", "tour-item-settings-menu-calendars")}
          {getItem("Виды оплаты", "paymentvids", "tour-item-settings-menu-paymentvids")}
          {getItem("Залы", "rooms", "tour-item-settings-menu-rooms")}
          {licenseModuleAccessControl(activeLicenseModules) ? getItem("Контроллеры", "ctrls") : null}
          {licenseModuleMessages(activeLicenseModules) ? getItem("Каналы", "channels") : null}
          {licenseModuleMessages(activeLicenseModules) ? getItem("Шаблоны", "patterns") : null}
          {getItem("Интеграция", "tokens", "tour-item-settings-menu-tokens")}
          {getItem("Отчеты", "reports", "tour-item-settings-menu-reports")}
          {getItem("Теги", "tags")}
        </>
      )}
    </div>
    <div className="col-one-col">{getPage()}</div>
  </div>) : (
  <div className="sport-form-content">
    <div className="col-one-main">
      <div className="col-one-col">
        <div style={{ fontWeight: 600, fontSize: 16, margin: 8 }}>Настройки</div>
        <div className='selector-filer-section'>
          <Select value={page} onChange={handlePageChange} style={{width: "100%"}}>
            {pagesMobile.map(p => (
              <Select.Option key={p.link} value={p.link}>
                {p.title}
              </Select.Option>
            ))}
          </Select>
          {page == "products" ? 
            (<img src="/images/filter.svg" className="mobile-top-img" alt="filter" onClick={() => setShowFilter(true)}/>) :
            (<></>)}
          {showFilter && <SettingsFilter value={filter} activePage={page} onClose={(filters) => { setShowFilter(false); if (filters) setFilter(filters); }}/>}
        </div>
        {getPage()}
      </div>
    </div>
  </div>
  )
}

export default Settings;